/**
 * @description 商品module
 */
import {PayHelpers} from '../../utils/payHelper'
import actions from '../actions/productAction'
import mutations from '../mutations/productMutation'
import getters from '../getters/productGetter'

const state = {
  skuDetail: {} // 单品详情
  , skuList: []
  // 商品支付环境
  , payEnv: PayHelpers.determinEnv()
  // 支付方式
  , payMethodList: []
  // 支付方式code
  , paymentSubCode: ''
  // 选中支付方式index
  , paySelectedIndex: 0
  // 二次支付支付方式
  , secondPayMethodsList: []
  // 选中二次支付方式index
  , secondPaySelectedIndex: 0
  // 二次支付方式code
  , secondPaymentSubCode: ''
  // 订单列表
  , orderList: []
}

export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
